module.exports = __webpack_public_path__ + "img/why-layanan.4877972e.svg";